import React from 'react'
import FormatCurrency from 'components/Common/FormatCurrency'
import Pill from 'components/Luxkit/Pill'
import styled from 'styled-components'
import rem from 'polished/lib/helpers/rem'
import Caption from 'components/Luxkit/Typography/Caption'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { getHotelOfferDisplayedValue } from 'lib/getOfferDisplayPricing'
import { isTourV2OfferType } from 'lib/offerTypes'

const DiscountPill = styled(Pill)`
  margin-top: ${rem(4)};
  padding-top: 0;
  padding-bottom: 0;
`

interface BaseProps {
  duration: string
  offerType?: App.OfferType
  saleUnit: string
  price: number
}

interface OfferProps {
  bundledWithFlightsOnly?: boolean
  flightPrice?: number
  value?: number
  shouldDisplayValue?: boolean
}

function HotelPriceContent({
  bundledWithFlightsOnly = false,
  duration,
  flightPrice = undefined,
  saleUnit,
  offerType,
  price,
  value,
  shouldDisplayValue,
}: BaseProps & OfferProps) {
  let hotelOfferDisplayValue
  const isTourV2 = isTourV2OfferType(offerType)
  if (!isTourV2) {
    hotelOfferDisplayValue = getHotelOfferDisplayedValue(bundledWithFlightsOnly, price, value, shouldDisplayValue, flightPrice)
  }

  return (
    <>
      <Caption variant="medium">
        {duration} from&nbsp;
        <BodyText variant="small" weight="bold" as="span">
          <FormatCurrency value={Math.ceil(price)} />
        </BodyText> /{saleUnit}
      </Caption>

      {!isTourV2 && hotelOfferDisplayValue.shouldShowDiscountPercent &&
        <DiscountPill kind="primary" variant="success">
          Save up to {hotelOfferDisplayValue.highestDiscountPercent}%
        </DiscountPill>
      }
    </>
  )
}

export default HotelPriceContent
